import { get, post } from './index'

export const getUserBalance = params => get('/org/balance/get', params)

export const getUserTradeRecodes = params => get('/org/balanceRecord/list', params)

export const getRenewList = params => get('/renew/list', params)

export const renewCalc = data => post('/renew/calc', data)

export const submitRenew = data => post('/renew/submit', data)

export const renewRecordList = params => get('/renew/records/search', params)
